<template>
  <page-view title="办件查询配置">
    <template slot="action">
      <a-button @click="onAdd" type="primary" icon="plus">新增办件查询配置</a-button>
    </template>
    <a-card>
      <a-row>
        <a-form :form="form">
          <table class="fx-form">
            <tr>
              <th>访问路径</th>
              <td>
                <a-form-item>
                  <a-input v-model="queryForm.webPath"></a-input>
                </a-form-item>
              </td>
            </tr>
            <tr>
              <td colspan="4" align="center">
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="reset">重置</a-button>
              </td>
            </tr>
          </table>
        </a-form>
      </a-row>
      <a-row style="margin-top:10px;">
        <s-table ref="table" :columns="columns" :data="loadData" :rowKey="(record) => record.id">
          <template slot="webPath" slot-scope="record">
            {{ record.webPath }}
          </template>
          <template slot="permission" slot-scope="record">
            {{ record.extras.permissionRemark }}
          </template>
          <template slot="state" slot-scope="record">
            {{ record.extras.state }}
          </template>
          <template slot="operation" slot-scope="record">
            <a-button type="primary" @click="onEdit(record)">修改</a-button>&nbsp;
            <a-popconfirm placement="bottom" title="是否确认删除?" @confirm="onDelete(record)">
              <a-button :loading="loading">删除</a-button>
            </a-popconfirm>
          </template>
        </s-table>
      </a-row>
    </a-card>
    <!-- 新增 -->
    <WFCaseQueryConfigAdd :visible="visible" @success="success" @cancel="cancel"/>
    <!-- 编辑 -->
    <WFCaseQueryConfigEdit ref="configEdit" :visible="editVisible" @success="editSuccess" @cancel="editCancel"/>
    <!-- 查看 -->
    <WFCaseQueryConfigView ref="configView" :visible="viewVisible" @cancel="viewCancel"/>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import STable from '@/components/Table'
import qs from 'qs'
import WFCaseQueryConfigEdit from './WFCaseQueryConfigEdit'
import WFCaseQueryConfigAdd from './WFCaseQueryConfigAdd'
import WFCaseQueryConfigView from './WFCaseQueryConfigView'

export default {
  name: 'WFCaseQueryConfig',
  components: {
    PageView,
    STable,
    WFCaseQueryConfigEdit,
    WFCaseQueryConfigAdd,
    WFCaseQueryConfigView
  },
  data () {
    return {
      visible: false,
      editVisible: false,
      viewVisible: false,
      loading: false,
      form: this.$form.createForm(this),
      queryForm: {
        webPath: ''
      },
      queryParam: {},
      loadData: (parameter) => {
        return this.$http.get('/api/1/workflow/config/query_config.json', {
          params: Object.assign(parameter, this.queryParam),
          paramsSerializer: function (params) {
            return qs.stringify(params, { indices: false })
          }
        }).then((res) => {
          return res
        })
      },
      columns: [
        {
          title: '访问路径',
          scopedSlots: { customRender: 'webPath' }
        },
        {
          title: '权限',
          width: '50%',
          scopedSlots: { customRender: 'permission' }
        },
        {
          title: '状态',
          scopedSlots: { customRender: 'state' }
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    }
  },
  methods: {
    // 搜索
    reset () {
      this.queryParam = {}
      this.queryForm = {}
      this.onSearch()
    },
    onSearch () {
      this.queryParam = { ...this.queryForm }
      this.$refs.table.refresh()
    },
    // 删除
    onDelete (record) {
      let that = this
      this.$http.post('/api/1/workflow/config/delete_config.json?id=' + record.id).then(function () {
        that.$message.success('删除成功')
        that.$refs.table.refresh()
      })
    },
    // 编辑
    onEdit (record) {
      this.editVisible = true
      this.$refs.configEdit.preEdit(record.id)
    },
    editSuccess () {
      this.editVisible = false
      this.$refs.table.refresh()
    },
    editCancel () {
      this.editVisible = false
    },
    // 添加
    onAdd () {
      this.visible = true
    },
    cancel () {
      this.visible = false
    },
    success () {
      this.visible = false
      this.$refs.table.refresh()
    },
    // 查看
    onView (record) {
      this.viewVisible = true
      this.$refs.configView.init(record.id)
    },
    viewCancel () {
      this.viewVisible = false
    }
  }
}
</script>

<style scoped></style>
